// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"43a42f8e","787":"f7663f2f"}[chunkId] + ".chunk.js";
};